import { useState, useEffect } from "react";
import axios from 'axios'
import styled from "styled-components";

import Frentes from "./Grid-boletin-frentes.js";
import Data from "./Grid-boletin-data.js";
import Caminhao from "./Grid-boletin-caminhao.js";

import Equipamento from "./Grid-boletin-equipamento.js";
import EquipamentoProposta from "./Grid-boletin-equipamento-proposta.js";
import DashboardGrafico from "./Grid-boletin-graficos.js";
import ModalDetalhesEquipamento from "./Modal-detalhes-equipamento.js";


import fundo2 from "../../../styles/fundo2.svg";
import RedButton from "../../ui/RedButton.js";


import logo1 from "./logo-1.png";
import logo2 from "./logo-2.png";
import logo3 from "./logo-3.png";
import logo4 from "./logo-4.png";
import logo5 from "./logo-5.png";


const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  
`;




const Div2 = styled.div`
  background-color: #fff;
  padding: 20px;
  display: flex;
  flex-direction: column;

  gap: 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 2px #ccc;
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 10px;
`;


const Title2 = styled.h2`
  display: flex;
  justify-content: space-between; 
  align-items: center;
  color: #008000;
  font-size: 28px;

  @media (max-width: 768px) {
    font-size: 20px;
    width: 90%;
  }

`;

const ActionsWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
  flex-wrap: wrap;
`;



const Imagem = styled.img`
  width: 600px;
  height: auto;

  @media (max-width: 768px) {
    width: 200px;
    height: auto;
  }
`;


export const TabButton = styled.button`
  width: 250px;
  font-weight: 600;
  padding: 8px 16px;
  border: none;
  cursor: pointer;
  border-radius: 10px;
  font-size: 18px;
  transition: all 0.3s ease;

  background-color: ${({ active }) => (active ? "#E5F7EE" : "#fff")};
  color: ${({ active }) => (active ? "#008000" : "#575757")};
  border: 1px solid #ccc;

  &:hover {
    background-color: ${({ active }) => (active ? "#d3f0e2" : "#f0f0f0")};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px #076333;
  }

  @media (max-width: 768px) {
    flex: 0 0 48%;
  }

  @media (max-width: 480px) {
    flex: 0 0 100%;
  }
`;


const Button3 = styled.button`
  background-color: #E5F7EE; // verde claro pastel
  color: #008000;            // verde forte
  font-size: 18px;
  font-weight: 600;
  padding: 8px 16px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background-color: #d3f0e2; // tom mais escuro no hover
  }

  @media (max-width: 780px) {
    font-size: 14px;
    padding: 6px 12px;
  }
`;

const Input = styled.input`
  width: 150px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
`;

const TabsSelect = styled.select`
  padding: 10px;
  font-size: 16px;
  border-radius: 6px;
  border: 1px solid #ccc;
  background-color: #fff;
  font-weight: bold;

  @media (min-width: 780px) {
    display: none; 

  }
`;

const TabsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 80vw;

  @media (max-width: 779px) {
    display: none; // esconde os botões no mobile
  }
`;



const ButtonContainer = styled.div`
  display: flex;
  justify-content: end; 
  margin: 5px;
`;


const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  
`;
const ModalContent = styled.div`
  background-color: #fafafa;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  max-height: 90vh; 

  border-radius: 10px;
  

`;


const Grid = ({ urlApi }) => {

  const token = localStorage.getItem('token');

  const [abaAtiva, setAbaAtiva] = useState("frentes");
  const [loadingImage, setLoadingImage] = useState(null);

  const imagens = [logo1, logo2, logo3, logo4, logo5];


  const trocarAbaComImagem = (novaAba) => {
    // Exibe imagem aleatória durante 1 segundo
    const imagemAleatoria = imagens[Math.floor(Math.random() * imagens.length)];
    setLoadingImage(imagemAleatoria);

    setTimeout(() => {
      setLoadingImage(null); // limpa imagem
      setAbaAtiva(novaAba);  // define aba ativa

      // Faz o fetch dos dados se ainda não tiver carregado
      if (novaAba === "graficos" && pizza.length === 0) buscarGrafico();
      if (novaAba === "frentes" && frentes.length === 0) buscarFrentes();
      if (novaAba === "data" && dia.length === 0) buscarData();
      // if (novaAba === "caminhao" && caminhao.length === 0) buscarCaminhao();
      if (novaAba === "equipamento" && equipamento.length === 0) buscarEquipamento();
    }, 1000); // 1 segundo de exibição da imagem
  };


  useEffect(() => {
    trocarAbaComImagem("frentes"); // define o nome da aba ativa
  }, []);



  const [dataIni, setDataIni] = useState('')
  const [dataFim, setDataFim] = useState('')
  const [frentes, setFrentes] = useState([])
  const [dia, setDia] = useState([])
  const [total, setTotal] = useState([])
  const [caminhao, setCaminhao] = useState("")
  const [equipamento, setEquipamento] = useState("")
  const [equipamentoDetalhes, setEquipamentoDetalhes] = useState("")

  const [pizza, setPizza] = useState("")
  const [semana, setSemana] = useState("")
  const [mes, setMes] = useState("")
  const [showGrid, setShowGrid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  const [isLoadingFrentes, setIsLoadingFrentes] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [isLoadingCaminhao, setIsLoadingCaminhao] = useState(false);

  const [isLoadingEquipamento, setIsLoadingEquipamento] = useState(false);
  const [isLoadingGrafico, setIsLoadingGrafico] = useState(false);



  const formatDateToDDMMYYYY = (dateStr) => {
    if (!dateStr) return '';
    const [yyyy, mm, dd] = dateStr.split('-');
    return `${dd}/${mm}/${yyyy}`;
  };

  const getListarSolinftech = async () => {
    if (!dataIni || !dataFim) {
      alert("Selecione a data inicial e final!");
      return;
    }

    setShowGrid(true);


    try {
      await Promise.all([
        buscarFrentes(),
        buscarData(),
        // buscarCaminhao(),
        buscarEquipamento(),
        buscarGrafico(),
        buscarTotal()
      ]);
    } catch (err) {
      console.error("Erro ao buscar dados do Solinftec", err);
    }
  };



  const buscarFrentes = async () => {
    setIsLoadingFrentes(true);
    try {
      const res = await axios.get(`${urlApi}solinftec/frentes`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          data_ini: formatDateToDDMMYYYY(dataIni),
          data_fim: formatDateToDDMMYYYY(dataFim),
        }
      });
      setFrentes(res.data);
    } catch (err) {
      console.error("Erro ao buscar frentes", err);
    } finally {
      setIsLoadingFrentes(false);
    }
  };


  const buscarData = async () => {
    setIsLoadingData(true);
    try {
      const res = await axios.get(`${urlApi}solinftec/data`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          data_ini: formatDateToDDMMYYYY(dataIni),
          data_fim: formatDateToDDMMYYYY(dataFim),
        }
      });
      setDia(res.data);
    } catch (err) {
      console.error("Erro ao buscar data", err);
    } finally {
      setIsLoadingData(false);
    }
  };

  const buscarCaminhao = async () => {
    setIsLoadingCaminhao(true);
    try {
      const res = await axios.get(`${urlApi}solinftec/caminhao`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          data_ini: formatDateToDDMMYYYY(dataIni),
          data_fim: formatDateToDDMMYYYY(dataFim),
        }
      });
      setCaminhao(res.data);
    } catch (err) {
      console.error("Erro ao buscar data", err);
    } finally {
      setIsLoadingCaminhao(false);
    }
  };

  const buscarEquipamento = async () => {
    setIsLoadingEquipamento(true);
    try {
      const res = await axios.get(`${urlApi}solinftec/equipamento`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          data_ini: formatDateToDDMMYYYY(dataIni),
          data_fim: formatDateToDDMMYYYY(dataFim),
        }
      });
      setEquipamento(res.data);

      const res1 = await axios.get(`${urlApi}solinftec/equipamento-detalhes`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          data_ini: formatDateToDDMMYYYY(dataIni),
          data_fim: formatDateToDDMMYYYY(dataFim),
        }
      });
      setEquipamentoDetalhes(res1.data);
    } catch (err) {
      console.error("Erro ao buscar data", err);
    } finally {
      setIsLoadingEquipamento(false);
    }
  };

  const buscarGrafico = async () => {
    setIsLoadingGrafico(true);
    try {
      const res = await axios.get(`${urlApi}solinftec/grafico-pizza`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          data_ini: formatDateToDDMMYYYY(dataIni),
          data_fim: formatDateToDDMMYYYY(dataFim),
        }
      });
      setPizza(res.data);

      const res1 = await axios.get(`${urlApi}solinftec/grafico-semana`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          data_ini: formatDateToDDMMYYYY(dataIni),
          data_fim: formatDateToDDMMYYYY(dataFim),
        }
      });
      setSemana(res1.data);

      const res2 = await axios.get(`${urlApi}solinftec/grafico-mes`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          data_ini: formatDateToDDMMYYYY(dataIni),
          data_fim: formatDateToDDMMYYYY(dataFim),
        }
      });
      setMes(res2.data);
    } catch (err) {
      console.error("Erro ao buscar data", err);
    } finally {
      setIsLoadingGrafico(false);
    }
  };


  const buscarTotal = async () => {
    const res = await axios.get(`${urlApi}solinftec/total`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        data_ini: formatDateToDDMMYYYY(dataIni),
        data_fim: formatDateToDDMMYYYY(dataFim),
      }
    });
    const dado = res.data;
    setTotal(Array.isArray(dado) ? dado : [dado]);
  };





  //---------------------------------------MODAL VER DE CHAMADO ABERTO---------------------------------------------------//

  const [verDetalhesEquipamento, setVerDetalhesEquipamento] = useState([])
  const [isModalOpenDetalhesEquipamento, setIsModalOpenDetalhesEquipamento] = useState(false);
  const modalDetalhesEquipamento = (item) => {
    setIsModalOpenDetalhesEquipamento(!isModalOpenDetalhesEquipamento);
    setVerDetalhesEquipamento(item);
  };


  return (
    <Div>
      <>
        {isModalOpenDetalhesEquipamento && (
          <ModalContainer>
            <ModalContent>
              <ButtonContainer>
                <RedButton onClick={() => {
                  modalDetalhesEquipamento();
                }}>
                  Fechar
                </RedButton>
              </ButtonContainer>
              <ModalDetalhesEquipamento
                equipamentoDetalhes={equipamentoDetalhes}
                verDetalhesEquipamento={verDetalhesEquipamento}


                equipamento={equipamento}
                showGrid={showGrid} isLoading={isLoadingEquipamento} total={total} dataIni={dataIni} dataFim={dataFim}
              />
            </ModalContent>
          </ModalContainer>
        )}




        {loadingImage ? (
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "82vh",           // altura total da tela
            width: "100%",
            textAlign: "center"
          }}>
            <Imagem
              src={loadingImage}
              alt="Carregando..."
              style={{
                animation: "zoomIn 0.8s ease-out forwards"
              }}
            />

            <style>
              {`
    @keyframes zoomIn {
      from {
        opacity: 0;
        transform: scale(0.8);
      }
      to {
        opacity: 1;
        transform: scale(1);
      }
    }
  `}
            </style>
          </div>
        ) : (
          <>


            <Div2>
              <HeaderRow>
                <Title2>
                  <h2>Solinftec - Aceitação CDC </h2>
                </Title2>
                <ActionsWrapper>
                  <Input type="date" value={dataIni} onChange={(e) => setDataIni(e.target.value)} />
                  <Input type="date" value={dataFim} onChange={(e) => setDataFim(e.target.value)} />
                  <Button3 onClick={getListarSolinftech}>Buscar</Button3>
                </ActionsWrapper>
              </HeaderRow>
              <>
                {showGrid && (
                  <>
                    {/* Versão para desktop */}
                    <TabsContainer>
                      <TabButton active={abaAtiva === "graficos"} onClick={() => trocarAbaComImagem("graficos")}>
                        Gráficos
                      </TabButton>
                      <TabButton active={abaAtiva === "frentes"} onClick={() => trocarAbaComImagem("frentes")}>
                        Frentes
                      </TabButton>
                      <TabButton active={abaAtiva === "data"} onClick={() => trocarAbaComImagem("data")}>
                        Data
                      </TabButton>
                      {/* <TabButton active={abaAtiva === "caminhao"} onClick={() => trocarAbaComImagem("caminhao")}>
                        Caminhão
                      </TabButton> */}
                      <TabButton active={abaAtiva === "equipamento"} onClick={() => trocarAbaComImagem("equipamento")}>
                        Equipamento
                      </TabButton>
                      <TabButton active={abaAtiva === "proposta"} onClick={() => trocarAbaComImagem("proposta")}>
                        Proposta
                      </TabButton>
                    </TabsContainer>

                    {/* Versão para mobile */}
                    <TabsSelect value={abaAtiva} onChange={(e) => trocarAbaComImagem(e.target.value)}>
                      <option value="graficos">Gráficos</option>
                      <option value="frentes">Frentes</option>
                      <option value="data">Dia</option>

                      {/* <option value="caminhao">Caminhão</option> */}
                      <option value="equipamento">Equipamento</option>
                      <option value="proposta">Proposta</option>
                    </TabsSelect>
                  </>
                )}
              </>



              {abaAtiva === "graficos" && <DashboardGrafico pizza={pizza} mes={mes} semana={semana} isLoading={isLoadingGrafico} frentes={frentes} />}
              {abaAtiva === "frentes" && <Frentes frentes={frentes} showGrid={showGrid} isLoading={isLoadingFrentes} total={total} dataIni={dataIni} dataFim={dataFim} />}
              {abaAtiva === "data" && <Data dia={dia} showGrid={showGrid} isLoading={isLoadingData} total={total} dataIni={dataIni} dataFim={dataFim} />}
              {/* {abaAtiva === "caminhao" && <Caminhao caminhao={caminhao} showGrid={showGrid} isLoading={isLoadingCaminhao} total={total} dataIni={dataIni} dataFim={dataFim} />} */}
              {abaAtiva === "equipamento" && <Equipamento equipamento={equipamento} equipamentoDetalhes={equipamentoDetalhes} modalDetalhesEquipamento={modalDetalhesEquipamento} showGrid={showGrid} isLoading={isLoadingEquipamento} total={total} dataIni={dataIni} dataFim={dataFim} />}
              {abaAtiva === "proposta" && <EquipamentoProposta equipamento={equipamento} equipamentoDetalhes={equipamentoDetalhes} modalDetalhesEquipamento={modalDetalhesEquipamento} showGrid={showGrid} isLoading={isLoadingEquipamento} total={total} dataIni={dataIni} dataFim={dataFim} />}
            </Div2>






          </>
        )}
      </>


    </Div >
  );
};



export default Grid;
